import { render, staticRenderFns } from "./BackupPolicy.vue?vue&type=template&id=1466e018&scoped=true"
import script from "./BackupPolicy.vue?vue&type=script&lang=ts"
export * from "./BackupPolicy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1466e018",
  null
  
)

export default component.exports